import React from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import ClearIcon from '@mui/icons-material/ClearRounded'
import Avatar from '../../components/Avatar/Avatar'
import { ScoreboardParticipant } from '../../utils/types'
import Text from '../../components/Text'

export type ScoreboardParticipantsListProps = {
  participants: ScoreboardParticipant[]
  deleteParticipant: (participantId: number) => void
  hasParticipants: boolean
  hasWriteAccess: boolean
  creatorUsername?: string
}

const ScoreboardParticipantsList = ({
  participants,
  deleteParticipant,
  hasParticipants,
  hasWriteAccess,
  creatorUsername,
}: ScoreboardParticipantsListProps) => {
  return (
    <>
      {!hasParticipants && (
        <Text center variant="medium" weight="bold" useDiv>No participants added yet</Text>
      )}
      {hasParticipants && (
        <Box display="flex" alignItems="center" columnGap={1} flexWrap="wrap">
          {participants.map((participant) => {
            const isCreator = !!creatorUsername && participant.username === creatorUsername

            return (
              <Box
                key={participant.id}
                sx={{
                  position: 'relative',
                  '&:hover .scoreboard-participants-delete': {
                    opacity: 1,
                    pointerEvents: 'auto',
                  },
                }}
              >
                <Avatar
                  src={participant.avatar}
                  alt={participant.full_name || participant.username || 'participant'}
                  sx={{ width: 32, height: 32 }}
                />

                {hasWriteAccess && !isCreator && (
                  <IconButton
                    className="scoreboard-participants-delete"
                    size="small"
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation()
                      deleteParticipant(participant.id)
                    }}
                    sx={{
                      position: 'absolute',
                      top: -6,
                      right: -6,
                      opacity: 0,
                      pointerEvents: 'none',
                      transition: 'opacity 150ms ease',
                      bgcolor: 'background.paper',
                      border: '1px solid',
                      borderColor: 'divider',
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            )
          })}
        </Box>
      )}
    </>
  )
}

export default ScoreboardParticipantsList

